module.exports = __webpack_public_path__ + "img/55_59.9844458f.png";